module.exports = __webpack_public_path__ + "img/map.705904c0.png";